import moment from "moment";

export const getTimetParamsFromWidgetConfig = (widgetConfig) => {
    let {widgetSettings} = widgetConfig
    let {interval} = widgetSettings

    let limit  = 10
    let begin = undefined
    let end = undefined
    let timebucket = undefined
    let bucketoffset = undefined

    switch (parseInt(interval)) {
        case 0: // 1h
            end = getUTCNow() 
            begin = getUTCNow() - 60*60
            limit = 0
        break;
        case 1: //24h
            end = getUTCNow() 
            begin = getUTCNow() - 24*60*60
            limit = 0
            timebucket = "hours"
            break;
        case 2: // week
            end = getUTCNow() 
            begin = getUTCNow() - 24*60*60*7
            limit = 0
            timebucket = "hours"
            break;
        case 3: // month
            end = getUTCNow() 
            begin = getUTCNow() - 24*60*60*30
            limit = 0
            timebucket = "days"
            break;
            case 4: // custom
            end = getUTCNow() 
            begin = getUTCNow() - 24*60*60*365
            limit = 0
            timebucket = "days"
            break;            
    
        default:
            break;
    }

    if (timebucket == "days") {
        bucketoffset = new Date().getTimezoneOffset()*60
    }
    return {begin, end, limit, timebucket, bucketoffset}
}

const getUTCNow = () => {
    let ts = moment.utc().valueOf()
    return Math.floor(ts / 1000);
}